
//EXTERNAL API
import BusinessService from "./BusinessService";

export const $flujoApi = {
    business: new BusinessService(),
};